'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartQuantitySelector = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _QuantitySelector2 = require('./QuantitySelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartQuantitySelector = exports.CartQuantitySelector = function (_QuantitySelector) {
  (0, _inherits3.default)(CartQuantitySelector, _QuantitySelector);

  function CartQuantitySelector(index, container) {
    (0, _classCallCheck3.default)(this, CartQuantitySelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartQuantitySelector.__proto__ || Object.getPrototypeOf(CartQuantitySelector)).call(this, container));

    _this.index = index;
    return _this;
  }

  (0, _createClass3.default)(CartQuantitySelector, [{
    key: 'onQuantityChanged',
    value: function onQuantityChanged(quantity) {
      this.updateQuantity(quantity);
    }
  }, {
    key: 'updateQuantity',
    value: function updateQuantity(qty) {
      (0, _pcSlateTools.updateCart)(this.index, qty);
    }
  }, {
    key: 'updateClasses',
    value: function updateClasses() {
      if (this.max != null && this.min != null && this.min >= this.max) {
        this.input.addClass('is-disabled');
        this.input.attr('disabled', 'disabled');
      } else {
        this.input.removeClass('is-disabled');
        this.input.removeAttr('disabled');
      }

      //Update Minus Button
      if (this.min != null && this.getValue() <= this.min) {
        this.minus.addClass('is-disabled');
        this.minus.attr('disabled', 'disabled');
      } else {
        this.minus.removeClass('is-disabled');
        this.minus.removeAttr('disabled');
      }
    }
  }]);
  return CartQuantitySelector;
}(_QuantitySelector2.QuantitySelector);